<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getInsureList" :total-size="totalNumber" :page-size="pageSize" ref="table"  layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <wt-table :list="tableData" :labels="tableLabels">
        <template slot="before">
          <slot name="before"/>
        </template>
        <template>
          <slot />
        </template>
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-insure-info-table'

export default {
  name: 'pt-insure-info-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getInsureList (page, next, size) {
      this.$emit('getInsureList', page, next, size)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
